<template>
  <div></div>
</template>

<script>
import { conditionSearch, search, getSearchInfo } from "@/api/table";
import { Message } from "element-ui";
// import Swal from 'sweetalert2';
export default {
  name: "base-mixins",
  components: {},
  props: { msg: String },
  data() {
    return {
      yearList: [],
      makeList: [],
      modelList: [],
      qualifierList: [],
      bodytypeList: [],
      searchkeywords: {
        year: "",
        make: "",
        model: "",
        qualifier: "",
        bodytype: "",
        sku: "",
      },
      value: "",
      isMobile: false,
      secondStatus: true,
      thirdStatus: true,
      fourStatus: true,
      fiveStatus: true,
      searchResutl: { qualifier: "" },
      searchResutl2: { qualifier: "" },
      firstTabLoadingStatus: false,
      tabData: "",
      picModel: "",
      noneFlag: false,
      hasSubmodel: false,
      submitFlag: true,
      showSeo: "",
    };
  },
  created() {
    // 如果显示设备为手机，dialog需要全屏显示
    this.fullScreen();
    // created之后，需要获取年份数据
    // console.log(innerWidth);
  },
  watch: {
    searchkeywords: {
      handler: function () {
        this.checkSubmit();
      },
      deep: true,
    },
  },
  mounted() {
    const params = {
      selectType: "YEAR",
      year: this.searchkeywords["year"],
      make: this.searchkeywords["make"],
    };
    this.applyCondition(params, "yearList");
    this.searchQueryInit();
    window.onresize = () => {
      this.fullScreen();
      this.getHeight(false);
      this.initSeo()
      // this.setTabPosition();
    };
  },
  methods: {
    getHeight(flag) {
      this.$nextTick(() => {
        const domObj = document.getElementsByClassName("index-container")[0];
        window.parent.postMessage(
          {
            type: "HEIGHT",
            height: domObj.offsetHeight,
          },
          "*"
        );
      });
      if (flag) {
        setTimeout(() => {
          const domObj = document.getElementsByClassName("index-container")[0];
          window.parent.postMessage(
            {
              type: "HEIGHT",
              height: domObj.offsetHeight,
            },
            "*"
          );
        }, 2000);
        setTimeout(() => {
          const domObj = document.getElementsByClassName("index-container")[0];
          window.parent.postMessage(
            {
              type: "HEIGHT",
              height: domObj.offsetHeight,
            },
            "*"
          );
        }, 8000);
      }
    },
    searchQueryInit() {
      console.log(this.$route);
      // 由xkglow中传过来的参数并设置初始列表
      this.searchkeywords.year = this.$route.query["year"];
      this.searchkeywords.make = this.$route.query["make"];
      this.searchkeywords.model = this.$route.query["model"];
      this.searchkeywords.sku = this.$route.query["sku"];
      // console.log(this.searchkeywords, 'searchkeywords')
      // this.picModel = this.$route.query["show"];
      if (this.searchkeywords.year !== "YEAR") {
        this.secondStatus = false;
        // year参数不为空，需要加载厂商list
        this.searchMake(false);
        if (this.searchkeywords.make !== "MAKE") {
          this.thirdStatus = false;
          this.searchModel();
          // this.handleClick();
          this.dealFourLevel();
        }
      }
    },
    // 判断是否是四级
    dealFourLevel() {
      const params = {
        selectType: "QUALIFIER",
        year: this.searchkeywords["year"],
        make: this.searchkeywords["make"],
        model: this.searchkeywords["model"],
      };
      conditionSearch(params).then((res) => {
        if (res.resultStatus) {
          const conditionArr = res.resultData.filter((item) => {
            return item.conditionName;
          });
          if (conditionArr.length == 0) {
            this.handleClick();
            this.checkSubmit();
          } else {
            this.fourStatus = false;
            this.hasSubmodel = true;
            this.qualifierList = [];
            for (let index = 0; index < conditionArr.length; index++) {
              this.qualifierList.push(conditionArr[index]["conditionName"]);
            }
            this.checkSubmit();
            this.$nextTick(() => {
              this.getHeight();
            });
          }
        }
      });
    },
    checkSubmit() {
      const searchkeywords = {
        year: this.searchkeywords.year,
        make: this.searchkeywords.make,
        model: this.searchkeywords.model,
        qualifier: this.searchkeywords.qualifier,
        bodytype: this.searchkeywords.bodytype,
      };
      let flag = true;
      if (this.qualifierList.length > 0) {
        for (let key in searchkeywords) {
          if (key != "bodytype" && !searchkeywords[key]) {
            this.submitFlag = true;
            flag = false;
          }
        }
      }
      if (this.bodytypeList.length > 0) {
        for (let key in searchkeywords) {
          if (!searchkeywords[key]) {
            this.submitFlag = true;
            flag = false;
          }
        }
      }
      const param = {
        year: searchkeywords.year,
        make: searchkeywords.make,
        model: searchkeywords.model,
      };
      for (let key in param) {
        if (!param[key]) {
          this.submitFlag = true;
          flag = false;
        }
      }
      flag ? (this.submitFlag = false) : (this.submitFlag = true);
    },
    handleClick() {
      const params = {
        year: this.searchkeywords["year"] || "",
        make: this.searchkeywords["make"] || "",
        model: this.searchkeywords["model"] || "",
        qualifier: this.searchkeywords["qualifier"] || "",
        bodyType: this.searchkeywords["bodytype"] || "",
        searchType: this.searchType,
      };
      if (
        !this.searchkeywords["year"] ||
        !this.searchkeywords["model"] ||
        !this.searchkeywords["make"]
      ) {
        Message({
          message: "Please fill all three dropdown options.",
          type: "warning",
          duration: 1000,
        });
        // const error = "Please fill all three dropdown options.";
        // Swal.fire({ title: error, timer: 2000, showConfirmButton: false });
        return;
      }
      if (this.qualifierList.length > 0 && !this.searchkeywords["qualifier"]) {
        Message({
          message: "Please fill all three dropdown options.",
          type: "warning",
          duration: 1000,
        });
        return;
      }
      if (this.bodytypeList.length > 0 && !this.searchkeywords["bodytype"]) {
        Message({
          message: "Please fill all three dropdown options.",
          type: "warning",
          duration: 1000,
        });
        return;
      }
      this.firstTabLoadingStatus = true;
      const path = this.$route.path;
      this.$router.replace({
        path: path,
        query: {
          year: this.searchkeywords["year"] || "",
          make: this.searchkeywords["make"] || "",
          model: this.searchkeywords["model"] || "",
          sku: this.searchkeywords["sku"] || "",
          // show: this.$route.query["show"] || ""
        },
      });
      window.parent.postMessage(
        {
          type: "TITLE",
          title: `${params.year} ${params.make} ${params.model}`,
        },
        "*"
      );
      search(params)
        .then((res) => {
          //console.log(res);
          this.firstTabLoadingStatus = false;
          this.searchResutl = res.resultData[0] || undefined;
          this.searchResutl2 = res.resultData[1] || undefined;
          //console.log(this.searchResutl2, "second result");
          // 因为qualifier数量不一定，需要使用循环生成tab的数据，用于生成动态tab
          let application = [];
          res.resultData.forEach((item) => {
            const applications = item.applications.filter((application) => {
              //console.log(application.products.length, "product length");
              return application.products.length !== 0;
            });
            application.push(...applications);
          });
          this.tabData =
            application.length > 0 ? { applications: application } : "";
          this.noneFlag = application.length == 0 ? true : false;
          //console.log(typeof res);
          //console.log(this.tabData);
          this.$nextTick(() => {
            this.getHeight(true);
          });
        })
        .catch((err) => {
          err;
          //console.log(err);
          this.firstTabLoadingStatus = false;
        });
    },
    initSeo() {
      const params = {
        year: this.searchkeywords["year"] || "",
        make: this.searchkeywords["make"] || "",
        model: this.searchkeywords["model"] || "",
        qualifier: this.searchkeywords["qualifier"] || "",
        bodyType: this.searchkeywords["bodytype"] || "",
        searchType: this.searchType,
      };
      getSearchInfo(params).then((res) => {
        console.log(res);
        this.showSeo = res.resultData.seo;
        this.showSeo = `{ "ContentRequirement": "SEO CONTENT REQUIREMENTS\n\nPageTitle: Enhance Your 2022 Toyota Camry with Top-Quality LED
            Lighting and Accessories\n\nMetaDescription: Discover how to elevate your 2022 Toyota Camry’s style and visibility
            with high-performance LED lighting solutions. Explore headlights, underglow kits, accent strips, and more for safer,
            brighter driving experiences.\n\nWordCount: 大约2000字\n\nPrimaryKeyword: 2022 Toyota Camry\n\nSecondary Keyword: LED
            lighting accessories, Camry LED upgrade, Toyota Camry lighting, interior and exterior LED kit\n\nGENERAL WRITING
            GUIDELINES:\n1. Use short paragraphs, headers, subheadings, bullets, and bolding\n2. Use the main keyword “[2022
            Toyota Camry]” 4 to 6 times in the body.\n3. Use secondary keywords naturally throughout the article.\n\nBelow is
            the structured Outline content reflecting these requirements, focusing on the 2022 Toyota Camry as a sedan, without
            offroad references:", "h1": "Welcome to Your 2022 Toyota Camry LED Lighting Experience", "h1Answer": "Whether you're
            seeking enhanced safety or a personalized style, our curated LED lighting solutions are designed to elevate your
            2022 Toyota Camry. Get ready to discover accessories that seamlessly blend performance, elegance, and unrivaled
            reliability for your everyday ride.", "h2": [ { "title": "Wide Range of LED Product Lines for the 2022 Toyota
            Camry", "h2Answer": "The 2022 Toyota Camry deserves top-notch automotive lighting upgrades that not only complement
            its sleek exterior but also boost visibility and driver confidence. Below you'll find a selection of LED product
            lines that have proven to be valuable assets for Camry owners looking to improve their overall driving experience in
            both day and night conditions.", "h3": [ { "title": "Headlights and Conversion Kits", "h3Answer": "Upgrade your
            stock Camry headlights to modern LED conversion kits that offer brighter, clearer illumination. Whether driving
            through city streets or on long road trips, these LED headlights ensure you see—and are seen—more effectively. LED
            conversion kits typically feature plug-and-play designs and require minimal installation time. The improved
            brightness helps reduce eyestrain, especially at night, giving you a safer drive in your 2022 Toyota Camry." }, {
            "title": "Fog Lights and Auxiliary Lamps", "h3Answer": "Foggy or rainy weather can challenge any driver, but
            installing LED fog lights on your 2022 Toyota Camry can significantly enhance low-visibility driving. These
            specially designed lights cut through dense fog, rain, or mist to reveal road hazards earlier. LED fog lights also
            offer energy efficiency and durability compared to traditional halogen bulbs, reducing long-term maintenance costs.
            Complement them with auxiliary lamps for added front-end lighting, ensuring you’ll never miss an important detail on
            the road." }, { "title": "Interior LED Strips and Accent Lighting", "h3Answer": "Transform your sedan’s cabin into a
            refined personal space by adding interior LED strip lights or accent kits. These flexible strips can highlight
            dashboard contours, door panels, and footwells, creating a modern and inviting atmosphere. You can even customize
            specific color schemes or brightness levels for your personal preference. Besides the aesthetic appeal, interior LED
            upgrades often consume less power, preserving your battery’s life while providing long-lasting and stylish
            lighting." } ] }, { "title": "Functional and Stylish LED Accessories for the 2022 Toyota Camry", "h2Answer": "LED
            accessories not only help highlight the bold lines and luxurious features of the Toyota Camry, but they also provide
            practicality and safety advantages. From specialized headlights to small accent strips, every innovation delivers a
            bright and dynamic sheen that transforms ordinary commutes into captivating journeys. Here are some must-have LED
            accessories for your 2022 Toyota Camry:", "h3": [ { "title": "Underbody Neon and LED Kits", "h3Answer": "Although
            the 2022 Toyota Camry is widely revered for its sophisticated look, adding an underbody LED kit can give it a sporty
            edge. These kits are typically water-resistant, come with multiple color options, and can be operated via remote or
            smartphone apps. An underbody kit is an excellent way to stand out at local meets or simply inject personality into
            your daily drive. The clean lines of the Camry pair perfectly with a well-placed glow for a subtle or dramatic
            effect, depending on your preference." }, { "title": "LED Trunk Strip and Cargo Lighting", "h3Answer": "When you
            open the trunk of your 2022 Toyota Camry, sufficient lighting makes a world of difference, especially at night or in
            dimly lit areas. An LED trunk strip or cargo area lighting kit offers improved visibility, helping you locate
            luggage or groceries more quickly. Coupled with interior accent lights, these trunk LED solutions preserve a
            consistent ambiance throughout your vehicle, ensuring both style and function go hand in hand." }, { "title": "Door
            Handle and Side Mirror LED Accents", "h3Answer": "For a refined finishing touch, consider adding LED accents to your
            door handles or side mirrors. Illuminate the handles as you approach your 2022 Toyota Camry, ensuring easy entry in
            the dark and an undeniable hint of luxury for onlookers. Side mirror lights, particularly those with sequential turn
            signals, increase your signaling visibility, providing a key safety benefit while simultaneously enhancing the
            vehicle’s overall sophistication." } ] }, { "title": "1213243452524546", "h2Answer":
            "Without offroad demands, the 2022 Toyota Camry still offers plenty of ways to improve driver comfort, car
            appearance, and personal satisfaction through LED lighting. Below, we address some of the most common questions
            about these upgrades and accessories to help you make the most informed decision for your Camry.", "h3": [ {
            "title": "How easy is it to install LED lighting on my 2022 Toyota Camry?", "h3Answer": "Most LED kits for the
            Toyota Camry come with plug-and-play connectors, detailed instructions, and necessary hardware. If you are
            well-versed in basic car maintenance, many lighting accessories can be installed within an hour or two. However, if
            you’re unsure about wiring or want a professional finish, it’s recommended to have a trusted automotive specialist
            handle the installation to keep everything neat and to prevent any electrical issues." }, { "title": "Can LED
            lighting improve my Camry’s resale value?", "h3Answer": "Yes. Thoughtfully installed LED upgrades can enhance your
            vehicle’s overall appeal by modernizing its lighting system. Many buyers see well-executed LED lighting improvements
            as a desirable feature, especially if they’re interested in energy efficiency, improved aesthetics, and better
            nighttime visibility. Make sure to use high-quality products so that the lighting system reflects positively on any
            future resale valuation." }, { "title": "Are LED lighting accessories legal in all areas?", "h3Answer": "While the
            primary upgrades like LED headlights and fog lights are universally accepted, laws about decorative lighting—such as
            underbody kits—vary by region. Always check local regulations before driving with certain accent lights or specific
            color combinations. If in doubt, consult local laws or ask a professional installer about permissible lighting
            modifications in your area. This ensures you remain fully compliant while still enjoying the enhancements to your
            2022 Toyota Camry." } ] } ], "ClosingCTA": "Experience the next level of style and functionality with our premium
            LED lighting solutions for your 2022 Toyota Camry. Discover how these accessories can transform your drives, enhance
            your safety, and showcase your personality on the road. Don’t wait—switch to a brighter, bolder Camry today!" }`;
        if (this.showSeo) {
          this.showSeo = this.showSeo.replace(/\r|\n/g, "");
          this.showSeo = JSON.parse(this.showSeo);
          window.parent.postMessage(
            {
              type: "SHOWSEO",
              show: true
            },
            "*"
          );
        }
        console.log(this.showSeo, "seoseoseoseoseoseo");
      });
    },
    fullScreen() {
      if (innerWidth <= 414) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    },
    /**
     * @description: 下拉框中的条件搜索
     * @param {object} params 搜索条件
     * @param {string} store 搜索结果存储位置
     */
    applyCondition(params, store) {
      conditionSearch(params).then((res) => {
        const data = res.resultData.filter((item) => {
          return item.conditionName;
        });
        this[store] = [];
        for (let index = 0; index < data.length; index++) {
          this[store].push(data[index]["conditionName"]);
        }
        //console.log(this[store]);
        this.checkSubmit();
      });
    },
    searchMake(clean) {
      this.secondStatus = false;
      const params = {
        selectType: "MAKE",
        year: this.searchkeywords["year"],
        make: this.searchkeywords["make"],
      };
      this.applyCondition(params, "makeList");
      if (clean) {
        this.searchkeywords["make"] = "";
        this.searchkeywords["model"] = "";
        this.searchkeywords["qualifier"] = "";
        this.searchkeywords["bodytype"] = "";
        this.qualifierList = [];
        this.bodytypeList = [];
      }
    },
    searchModel(clean) {
      this.thirdStatus = false;
      const params = {
        selectType: "MODEL",
        year: this.searchkeywords["year"],
        make: this.searchkeywords["make"],
      };
      this.applyCondition(params, "modelList");
      if (clean) {
        this.searchkeywords["model"] = "";
        this.searchkeywords["qualifier"] = "";
        this.searchkeywords["bodytype"] = "";
        this.qualifierList = [];
        this.bodytypeList = [];
      }
    },
    searchQualifier(clean) {
      this.fourStatus = false;
      const params = {
        selectType: "QUALIFIER",
        year: this.searchkeywords["year"],
        make: this.searchkeywords["make"],
        model: this.searchkeywords["model"],
      };
      this.applyCondition(params, "qualifierList");
      if (clean) {
        this.searchkeywords["qualifier"] = "";
        this.searchkeywords["bodytype"] = "";
        this.qualifierList = [];
        this.bodytypeList = [];
      }
    },
    searchBodytype(clean) {
      this.hasSubmodel = false;
      this.fiveStatus = false;
      const params = {
        selectType: "BODYTYPE",
        year: this.searchkeywords["year"],
        make: this.searchkeywords["make"],
        model: this.searchkeywords["model"],
        qualifier: this.searchkeywords["qualifier"],
      };
      this.applyCondition(params, "bodytypeList");
      if (clean) {
        this.searchkeywords["bodytype"] = "";
        this.bodytypeList = [];
      }
    },
  },
};
</script>

<style scoped></style>
